import { RequestState } from '../../../types'

export type Contact = {
  id: string
  name: string
  email: string
  phone: string
  mobile: string
  deleteRequestState: RequestState
}

export type ContactForm = {
  name: string
  email: string
  phone: string
  mobile: string
}

export type ContactsSettingsState = {
  contacts: Contact[]
  loadRequestState: RequestState
  form: {
    requestState: RequestState
    contact: ContactForm
  }
}

export const emptyContactForm: ContactForm = {
  name: '',
  email: '',
  phone: '',
  mobile: ''
}

export const initialContactsSettingsState: ContactsSettingsState = {
  contacts: [],
  loadRequestState: RequestState.NotLoaded,
  form: {
    requestState: RequestState.NotLoaded,
    contact: emptyContactForm
  }
}
